var _rect, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCup(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_170107",
    "data-name": "Group 170107",
    xmlns: "http://www.w3.org/2000/svg",
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_150969",
    "data-name": "Rectangle 150969",
    width: 80,
    height: 80,
    rx: 12,
    fill: "rgba(101,167,67,0.1)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_38521",
    "data-name": "Path 38521",
    d: "M27.778,0H12.222A3.254,3.254,0,0,0,8.951,3.347c.014.368.028.736.049,1.1H1.667A1.663,1.663,0,0,0,0,6.111c0,6.431,2.326,10.9,5.451,13.938a22.272,22.272,0,0,0,9.59,5.264,3.531,3.531,0,0,1,2.736,3.167,2.635,2.635,0,0,1-2.632,2.632H13.333a2.222,2.222,0,1,0,0,4.444H26.667a2.222,2.222,0,0,0,0-4.444H24.854a2.635,2.635,0,0,1-2.632-2.632,3.515,3.515,0,0,1,2.736-3.167,22.254,22.254,0,0,0,9.6-5.264C37.674,17.014,40,12.542,40,6.111a1.663,1.663,0,0,0-1.667-1.667H31c.021-.361.035-.722.049-1.1A3.254,3.254,0,0,0,27.778,0ZM3.4,7.778H9.257c.632,6.257,2.028,10.437,3.6,13.236A17.25,17.25,0,0,1,7.778,17.66,14.764,14.764,0,0,1,3.4,7.778ZM32.229,17.66a17.25,17.25,0,0,1-5.083,3.354c1.576-2.8,2.972-6.979,3.6-13.236h5.861a14.827,14.827,0,0,1-4.375,9.882Z",
    transform: "translate(20 23)",
    fill: "#65a743"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCup);
export default __webpack_public_path__ + "static/media/cup.0eead15d2ab903721ed908f87ca6036d.svg";
export { ForwardRef as ReactComponent };